import { render, staticRenderFns } from "./AnswerDescription.vue?vue&type=template&id=18f6ddc8&scoped=true"
import script from "./AnswerDescription.vue?vue&type=script&lang=js"
export * from "./AnswerDescription.vue?vue&type=script&lang=js"
import style0 from "./AnswerDescription.vue?vue&type=style&index=0&id=18f6ddc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f6ddc8",
  null
  
)

export default component.exports